module.exports = __webpack_public_path__ + "img/sound-button.65b62bdf.png";